import { render, staticRenderFns } from "./ShuttleList.vue?vue&type=template&id=bde7816a&"
import script from "./ShuttleList.vue?vue&type=script&lang=js&"
export * from "./ShuttleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports